<template>
    <div class="search-content-wrap">
        <v-divider></v-divider>
        <v-card>
            <v-container class="filter-heading">
                <v-layout wrap justify-space-between align-content-center align-end>
                    <v-flex xs12 md9>
                        <h3 class="mt-3 red--text">{{ $t('Views.Search.product_search_title') }}</h3>
                        <span v-html="searchDesc"></span>
                    </v-flex>
                    <v-flex xs12 md3>
                        <user-heading></user-heading>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-card>
        <v-card color="primary">
            <v-container class="filter-content">
                <v-layout>
                    <v-flex>
                        <v-form action="#" @submit.prevent="submitSearch">
                            <v-layout justify-center :wrap="$vuetify.breakpoint.smAndDown">
                                <v-flex class="mx-2">
                                    <v-layout>
                                        <v-subheader>{{ $t('Views.Search.product_code_label') }}</v-subheader>
                                        <v-text-field
                                                v-model="productSearchParams.productCode"
                                                :label="$t('Views.Search.product_code_label')"
                                                solo
                                                @keyup.enter="submitSearch"
                                        ></v-text-field>
                                    </v-layout>
                                </v-flex>
                                <v-flex class="mx-2">
                                    <v-layout>
                                        <v-subheader>{{ $t('Views.Search.chemical_nature_label') }}</v-subheader>
                                        <v-select
                                                :items="chemicalNatureOptions"
                                                item-text="label"
                                                item-value="id.key"
                                                v-model="productSearchParams.chemicalNature"
                                                clearable
                                                :label="$t('Views.Search.chemical_nature_label')"
                                                solo
                                                @change="submitSearch"
                                        ></v-select>
                                    </v-layout>
                                </v-flex>
                                <v-flex class="mx-2">
                                    <v-layout>
                                        <v-subheader>{{ $t('Views.Search.surface_finish_label') }}</v-subheader>
                                        <v-select
                                                :items="surfaceFinishOptions"
                                                item-text="label"
                                                item-value="id.key"
                                                v-model="productSearchParams.finishing"
                                                clearable
                                                :label="$t('Views.Search.surface_finish_label')"
                                                solo
                                                @change="submitSearch"
                                        ></v-select>
                                    </v-layout>
                                </v-flex>
                                <v-flex class="mx-2">
                                    <v-layout>
                                        <v-subheader>{{ $t('Views.Search.appearance_label') }}</v-subheader>
                                        <v-select
                                                :items="aspectOptions"
                                                item-text="label"
                                                item-value="id.key"
                                                v-model="productSearchParams.aspect"
                                                clearable
                                                :label="$t('Views.Search.appearance_label')"
                                                solo
                                                @change="submitSearch"
                                        ></v-select>
                                    </v-layout>
                                </v-flex>
                            </v-layout>
                            <v-layout justify-center :wrap="$vuetify.breakpoint.smAndDown">
                                <v-flex class="mx-2">
                                    <v-layout>
                                        <v-subheader>{{ $t('Views.Search.application_label') }}</v-subheader>
                                        <v-select
                                                :items="applicationOptions"
                                                item-text="label"
                                                item-value="id.key"
                                                v-model="productSearchParams.application"
                                                clearable
                                                :label="$t('Views.Search.application_label')"
                                                solo
                                                @change="submitSearch"
                                        ></v-select>
                                    </v-layout>
                                </v-flex>
                                <v-flex class="mx-2">
                                    <v-layout>
                                        <v-subheader>{{ $t('Views.Search.internal_external_label') }}</v-subheader>
                                        <v-select
                                                :items="internalExterior"
                                                v-model="productSearchParams.internalExternal"
                                                clearable
                                                :label="$t('Views.Search.internal_external_label')"
                                                solo
                                                @change="submitSearch"
                                        ></v-select>
                                    </v-layout>
                                </v-flex>
                                <v-flex class="mx-2">
                                    <v-layout>
                                        <v-subheader>{{ $t('Views.Search.ral_label') }}</v-subheader>
                                        <v-text-field
                                                v-model="productSearchParams.ral"
                                                :label="$t('Views.Search.ral_label')"
                                                solo
                                                @keyup.enter="submitSearch"
                                        ></v-text-field>
                                    </v-layout>
                                </v-flex>
                                <v-flex class="mx-2">
                                    <v-layout>
                                        <v-subheader>{{ $t('Views.Search.color_label') }}</v-subheader>
                                        <v-text-field v-model="productSearchParams.colorDesc"
                                                      :label="$t('Views.Search.color_label')"
                                                      solo
                                                      @keyup.enter="submitSearch"
                                        ></v-text-field>
                                    </v-layout>
                                </v-flex>
                            </v-layout>
                        </v-form>
                    </v-flex>

                    <v-flex sm1 class="search-submit-wrap mb-3">
                        <v-layout align-end row fill-height>
                            <v-btn class="search-button" @click="submitSearch" icon round color="dark"
                                   id="detailsSection">
                                <v-icon>mdi-magnify</v-icon>
                            </v-btn>
                        </v-layout>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-card>
        <v-card color="black">&nbsp;</v-card>

        <v-card v-if="productDetailsShow">
            <v-container>
                <v-btn
                        color="black"
                        class="white--text"
                        @click="productDetails = {}"
                        round>
                    <v-icon left dark>mdi-arrow-left-bold-circle</v-icon>
                    {{ $t('Views.Search.back_to_search') }}
                </v-btn>
            </v-container>

            <v-container>
                <material-product-detail :product="productDetails"></material-product-detail>
            </v-container>
        </v-card>

        <v-container v-if="productsFounded && !productDetailsShow" fluid justify-center>
            <v-layout>
                <v-flex xs12 class="text-xs-center">
                    <v-pagination
                            v-model="pagination.page"
                            @input="changePage"
                            :length="paginationPageCount"
                            :total-visible="8"
                            circle
                    ></v-pagination>
                </v-flex>
            </v-layout>

            <v-layout justify-center wrap>
                <v-flex sm12>
                    <v-container fluid justify-center>
                        <v-layout row wrap fill-height xs12 sm6 md4>
                            <product-item v-for="productItem in products"
                                          @show-product-details="showProductDetails"
                                          :product="productItem"
                                          :key="productItem.code"></product-item>
                        </v-layout>
                    </v-container>
                </v-flex>
            </v-layout>

            <v-layout>
                <v-flex xs12 class="text-xs-center">
                    <v-pagination
                            v-model="pagination.page"
                            @input="changePage"
                            :length="paginationPageCount"
                            :total-visible="8"
                            circle
                    ></v-pagination>
                </v-flex>
            </v-layout>
        </v-container>
        <v-container v-if="searchIsEmpty" fluid justify-center>
            <v-layout justify-center wrap>
                <v-flex sm12 class="text-xs-center">
                    <h3>{{ $t('Views.Search.search_empty') }}</h3>
                </v-flex>
            </v-layout>
        </v-container>

        <v-snackbar
                v-model="snackbar.show"
                :color="snackbar.color"
                :timeout="snackbar.timeout"
                top>
            {{ snackbar.text }}
        </v-snackbar>

    </div>
</template>

<script>
    import Vue from 'vue'
    import i18n from '@/i18n'
    import httpService from '@/service/httpService'
    import productListItem from '@/views/productListItem'
    import {mapGetters} from 'vuex'
    import userHeading from '@/components/core/UserHeading'

    export default Vue.extend({
        name: 'search',
        components: {
            'product-item': productListItem,
            'user-heading': userHeading
        },
        data() {
            return {
                defaultLocale: 'it_IT',
                chemicalNatureOptions: [],
                surfaceFinishOptions: [],
                aspectOptions: [],
                applicationOptions: [],
                productSearchParams: {
                    productCode: '',
                    chemicalNature: '',
                    finishing: '',
                    aspect: '',
                    colorDesc: '',
                    ral: '',
                    package: '',
                    application: '',
                    internalExternal: '',
                    locale: '',
                    offset: 0
                },
                products: [],
                productDetails: {},
                searchIsEmpty: false,
                pagination: {
                    productPerPage: 6,
                    page: 1,
                    count: 0
                },
                snackbar: {
                    show: false,
                    color: '',
                    timeout: 6000,
                    text: ''
                },
            }
        },
        mounted() {
            this.checkUrlParameters()
        },
        watch: {
            '$route'(to, from) {
                this.mapSearchParamsFromRoute()
                this.productSearchCount()
                this.searchProducts()
            }
        },
        methods: {
            goToLogin() {
                this.$router.push({name: 'Login'})
            },
            submitSearch() {
                this.pagination.page = 1
                this.productSearchParams.offset = (this.pagination.page * this.pagination.productPerPage) - this.pagination.productPerPage
                if (this.productSearchValid) {
                    this.$router.push({query: Object.assign({}, this.productSearchParams)})
                } else {
                    this.snackbar.text = this.$t('Views.Search.search_params_empty')
                    this.snackbar.color = 'error'
                    this.snackbar.show = true
                }
            },
            mapSearchParamsFromRoute() {
                this.productSearchParams.productCode = this.$route.query.productCode
                this.productSearchParams.chemicalNature = this.$route.query.chemicalNature
                this.productSearchParams.finishing = this.$route.query.finishing
                this.productSearchParams.aspect = this.$route.query.aspect
                this.productSearchParams.colorDesc = this.$route.query.colorDesc
                this.productSearchParams.ral = this.$route.query.ral
                this.productSearchParams.package = this.$route.query.package
                this.productSearchParams.application = this.$route.query.application
                this.productSearchParams.internalExternal = this.$route.query.internalExternal
                this.pagination.page = 1 + (this.$route.query.offset / this.pagination.productPerPage)
            },
            changePage() {
                this.productSearchParams.offset = (this.pagination.page * this.pagination.productPerPage) - this.pagination.productPerPage
                this.$router.push({query: Object.assign({}, this.productSearchParams)})
            },
            searchProducts() {
                if (this.productSearchValid) {
                    httpService.get('/products-manager/products/filters/multi', {params: this.productSearchQuery})
                        .then((productsFound) => {
                            this.productDetails = {};
                            if (productsFound.length > 0) {
                                this.products = productsFound
                                this.searchIsEmpty = false
                            } else {
                                this.products = []
                                this.searchIsEmpty = true
                            }

                            scrollTo(0, document.getElementById('detailsSection').getBoundingClientRect().top -100 + window.pageYOffset)
                        })
                        .catch((error) => {
                            console.error(error);
                            this.snackbar.text = error.message
                            this.snackbar.color = 'error'
                            this.snackbar.show = true
                        });
                } else {
                    this.snackbar.text = this.$t('Views.Search.search_params_empty')
                    this.snackbar.color = 'error'
                    this.snackbar.show = true
                }
            },
            productSearchCount() {
                if (this.productSearchValid) {
                    httpService.get('/products-manager/products/filters/multi/count', {params: this.productSearchQuery})
                        .then((productsCount) => {
                            this.pagination.count = productsCount
                        })
                        .catch((error) => {
                            console.error(error);
                            this.snackbar.text = error.message
                            this.snackbar.color = 'error'
                            this.snackbar.show = true
                        });
                } else {
                    this.snackbar.text = this.$t('Views.Search.search_params_empty')
                    this.snackbar.color = 'error'
                    this.snackbar.show = true
                }
            },
            showProductDetails(productItemDetail) {
                this.productDetails = productItemDetail;
            },
            checkUrlParameters() {
                let needSearchRefresh = false

                if (this.$route.query.locale) {
                    this.defaultLocale = this.$route.query.locale == 'cz_CZ' ? 'cs_CZ' : this.$route.query.locale

                    this.$store.dispatch("ACTION_SET_LOCALE", this.defaultLocale)
                        .then(() => i18n.locale = this.locale.substr(0, 2))
                        .catch((error) => {
                            console.error('Error during locale update', error);
                    })
                } else {
                    i18n.locale = this.locale.substr(0, 2)
                }

                this.loadCombos()

                Object.keys(this.$route.query).filter(key => key in this.productSearchParams).forEach(key => {
                    this.productSearchParams[key] = this.$route.query[key]
                    // If locale is the only param, don't refresh the search
                    if ("locale" !== key) {
                        needSearchRefresh = true
                    }
                })

                if (needSearchRefresh) {
                    this.submitSearch()
                }
            },
            loadCombos() {
                httpService.get('/products-manager/combos/chemical-natures?locale=' + this.locale)
                    .then(combos => {
                        this.chemicalNatureOptions = combos
                    })
                    .catch(err => {
                        console.error(err)
                    })

                httpService.get('/products-manager/combos/finishing?locale=' + this.locale)
                    .then(combos => {
                        this.surfaceFinishOptions = combos
                    })
                    .catch(err => {
                        console.error(err)
                    })

                httpService.get('/products-manager/combos/aspects?locale=' + this.locale)
                    .then(combos => {
                        this.aspectOptions = combos
                    })
                    .catch(err => {
                        console.error(err)
                    })

                httpService.get('/products-manager/combos/applications?locale=' + this.locale)
                    .then(combos => {
                        this.applicationOptions = combos
                    })
                    .catch(err => {
                        console.error(err)
                    })
            },
            logout() {
                this.$store.dispatch('ACTION_LOGOUT')
                this.$router.push({name: 'Search'})
            }
        },
        computed: {
            ...mapGetters(['getProfile', 'getLanguage']),
            locale() {
                if (this.getLanguage) {
                    return this.getLanguage
                }
                return this.defaultLocale
            },
            searchDesc() {
                return this.$t('Views.Search.search_description')
            },
            internalExterior() {
                return [
                    { text: this.$t('Views.Search.outdoor'), value: 'OUT' },
                    { text: this.$t('Views.Search.indoor'), value: 'IN' },
                    { text: this.$t('Views.Search.outdoor') + ' ' + this.$t('Views.Search.indoor'), value: 'INOUT' }
                ]
            },
            productSearchQuery() {
                return Object.assign({},
                    {locale: this.locale, offset: this.paginationOffset},
                    {productCode: this.$route.query.productCode},
                    {chemicalNature: this.$route.query.chemicalNature},
                    {finishing: this.$route.query.finishing},
                    {aspect: this.$route.query.aspect},
                    {colorDesc: this.$route.query.colorDesc},
                    {ral: this.$route.query.ral},
                    {package: this.$route.query.package},
                    {application: this.$route.query.application},
                    {internalExternal: this.$route.query.internalExternal},
                    {indoor: this.indoorQueryParam},
                    {outdoor: this.outdoorQueryParam}
                )
            },
            productSearchValid() {
                return this.productSearchParams.productCode ||this.productSearchParams.chemicalNature 
                    || this.productSearchParams.finishing || this.productSearchParams.aspect 
                    || this.productSearchParams.colorDesc || this.productSearchParams.ral 
                    || this.productSearchParams.package || this.productSearchParams.application 
                    || this.productSearchParams.internalExternal
            },
            indoorQueryParam() {
                return this.productSearchParams.internalExternal === 'INOUT' || this.productSearchParams.internalExternal === 'IN' ? 'SI' : ''
            },
            outdoorQueryParam() {
                return this.productSearchParams.internalExternal === 'INOUT' || this.productSearchParams.internalExternal === 'OUT' ? 'SI' : ''
            },
            paginationPageCount() {
                return Math.ceil(this.pagination.count / this.pagination.productPerPage)
            },
            paginationPage() {
                return this.pagination.page - 1
            },
            paginationOffset() {
                return this.pagination.productPerPage * this.paginationPage
            },
            productsFounded() {
                return this.products.length > 0
            },
            productDetailsShow() {
                return !(Object.entries(this.productDetails).length === 0 && this.productDetails.constructor === Object)
            }
        }
    })
</script>

<style lang="scss" scoped>
    @import '../styles/material-dashboard/variables.scss';

    .search-content-wrap {
        clear: both;
    }

    .filter-content {
        .v-subheader {
            color: $white;
        }
    }

    .search-button {
        margin-top: 0px;
        background-color: $grey-900;
    }
</style>

